// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"8fbc77b5","703":"7ebfbbfa","787":"6aec66b5"}[chunkId] + ".chunk.js";
};